module.exports = __webpack_public_path__ + "img/step1.add4fdd9.png";